import {useEffect} from 'react'
import {getConfig} from '@salesforce/pwa-kit-runtime/utils/ssr-config'
import {loadOnInteractionOrIdle} from './load-on-interaction'

export function KlarnaScript() {
    useEffect(() => {
        // Check if script is already loaded
        if (document.getElementById('klarna-script')) {
            return
        }

        const config = getConfig()
        const clientId = config.app.KLARNA_CLIENT_ID
        const environment = config.app.KLARNA_OSMSDK_ENV

        // Defer Klarna loading until user interaction or idle
        // This improves TTI by not blocking the main thread on initial load
        const cleanup = loadOnInteractionOrIdle(() => {
            // Double-check in case it was loaded during the delay
            if (document.getElementById('klarna-script')) {
                return
            }

            const script = document.createElement('script')
            script.nonce = window.__CSP_NONCE__
            script.id = 'klarna-script'
            script.src = 'https://js.klarna.com/web-sdk/v1/klarna.js'
            script.async = true
            script.setAttribute('data-environment', environment)
            script.setAttribute('data-client-id', clientId)

            document.head.appendChild(script)
        }, { timeout: 3000 })

        // Cleanup
        return () => {
            cleanup?.()
            const existingScript = document.getElementById('klarna-script')
            if (existingScript) {
                existingScript.remove()
            }
        }
    }, [])

    return null // Renders nothing
}
